import { createContext, PropsWithChildren, useContext, useEffect } from 'react'

import type { TribeRouterType } from './@types/index.js'

export const defaultRouter: TribeRouterType = {
  Link: ({ children, ...props }) => <a {...props}>{children}</a>,
  Redirect: ({ to }) => {
    useEffect(() => {
      window.history.pushState({}, '', to)
    }, [])
    return null
  },
  redirect: href => {
    window.location.href = href
  },
  push: path => {
    window.history.pushState({}, '', path)
  },
  replace: path => {
    window.history.replaceState({}, '', path)
  },
  params: {},
  location:
    typeof window === 'object'
      ? window.location
      : { pathname: '/', search: '' },
}

export const RouterContext = createContext<TribeRouterType>(defaultRouter)

export const useRouter = () => {
  return useContext(RouterContext)
}

RouterContext.displayName = 'TribeRouter'

export const TribeRouter = ({
  children,
  ...rest
}: PropsWithChildren<TribeRouterType>) => {
  return (
    <RouterContext.Provider value={rest || defaultRouter}>
      {children}
    </RouterContext.Provider>
  )
}
